import { gql } from 'apollo-angular';
export const userProfileFragment = gql`
  fragment UserProfileFragment on User {
    user_profile {
      id
      avatar_color
      avatar_photo
      bs_history_time_setting
    }
  }
`;
export const userPersonFragment = gql`
  fragment UserPersonFragment on User {
    person {
      id
      name
    }
  }
`;
export const baseUserInfoFragment = gql`
  fragment UserInfoFragment on User {
    id
    username
    mapsApiKey
  }
`;
export default {
  baseUserInfoFragment,
  userPersonFragment,
  userProfileFragment,
};
